import './style.scss'
import { useContext, useEffect, useState } from 'react'
import utility from 'src/utils/utility'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { AbsoluteContainer, AppSpan, CustomContainer, FlexRow, PageTitle, PageWrapper } from 'src/style'
import { Categories, Fees, SandboxUsers, ServiceProviders, Tags } from 'src/component'
import * as device from 'react-device-detect'

const tabsInfo = [
    {label: 'Categories', value: 'categories'},
    {label: 'Service providers', value: 'service-providers'},
    {label: 'Sandbox users', value: 'sandbox-users'},
    {label: 'Fees', value: 'fees'},
    {label: 'Tags', value: 'tags'},
]

const Administration = () => {
    const {info: {selectedAdminTab}, setInfoProperty} = useContext(AppInfoContext)
    const [selectedTab, setSelectedTab] = useState('') 

    useEffect(() => {
        if (!selectedTab) setSelectedTab(selectedAdminTab || 'categories')
    }, [selectedAdminTab])

    function handleSelectedTab (tab: string) {
        setSelectedTab(tab)
        setInfoProperty('selectedAdminTab', tab)
    }

    return (
        <PageWrapper>
            <PageTitle 
                color='#101828' textSize='3' fontWeight="500"
            >
                Administration
            </PageTitle>
            <CustomContainer topMargin='2.5'>
                <CustomContainer 
                    bottomMargin='2'
                    className='scrollable-container'
                >
                    <FlexRow
                        gap='2' height='4' alignItems='flex-start'
                        className='tab-container'
                    >
                        {
                            tabsInfo.map((item, index) => {
                                return (
                                    <AppSpan
                                        fontWeight={device.isFirefox ? '400' : '500'}
                                        cursor='pointer'
                                        color={selectedTab === item.value ? '#0A756F' : '#667085'}
                                        onClick={() => handleSelectedTab(item.value)}
                                        key={index}
                                >
                                        {item.label}
                                    </AppSpan>
                                )
                            })
                        }
                        <AbsoluteContainer 
                            bottom='0' 
                            left={selectedTab === 'categories' ? '0' : selectedTab === 'service-providers' ? '9.6' : selectedTab === 'sandbox-users' ? '23.6' : selectedTab === 'fees' ? '36' : '41.3'}
                        >
                            <CustomContainer
                                width={selectedTab === 'categories' ? '7.5' : selectedTab === 'service-providers' ? '12.5' : selectedTab === 'sandbox-users' ? '10.9' : '4'}
                                height='0.2' bgColor='#0A756F'
                            />
                        </AbsoluteContainer>
                    </FlexRow>
                </CustomContainer>
                { selectedTab === 'categories' ?
                    <Categories/>
                    : selectedTab === 'sandbox-users' ?
                        <SandboxUsers />
                        : selectedTab === 'service-providers' ?
                            <ServiceProviders />
                            : selectedTab === 'fees' ?
                                <Fees />
                                : <Tags />
                }
            </CustomContainer>
        </PageWrapper>
    )
}

export default utility.routeData('administration', 'Administration', <Administration/>)
